import EditDate from "../components/EditDate"
import InteractiveMap from "../components/InteractiveMap"
import { getLastUpdated } from "../functions/utils"
import FreeText from "./FreeText"

const HotelSimple = ({ data }) => {
    const { internalNameEntryTitle, hotelAddress, hotelLocation, additionalInfo } = data.fields
    const date = getLastUpdated(data)
    return (
        <div>
            <div className="flex-between-centered">
                <b className="content_h4" style={{marginBottom: 15}}>{internalNameEntryTitle}</b>
                <EditDate date={date} />
            </div>
            {hotelAddress && (
                <div style={{marginTop: 15}}>
                    <b>Hotel Address:</b>
                    <p>{hotelAddress}</p>
                </div>
            )}
            {hotelLocation && <InteractiveMap address={hotelAddress} lng={hotelLocation.lon} lat={hotelLocation.lat} />}
            {additionalInfo && <FreeText data={additionalInfo} slug='additionalInfo' />}
        </div>
    )
}

export default HotelSimple